<i18n
  src="@/locales/components/views/agro_exporter/production/uniq_final_packing_list/show_container/tabs/packages.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/package.yml" lang="yaml"></i18n>
<template>
  <div v-if="(package_groups.length > 0)">
    <div class="mt-8 flex flex-col">
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.package.producer") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.package.exporter_process_crop_category") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.package.exporter_process_crop_variety") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.package.exporter_process_brand") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.package.exporter_process_crop_package") }}
                  </th>

                  <th
                    scope="col"
                    class="table-header-cell"
                    v-for="size in crop_sizes"
                    :key="size.id"
                  >
                    {{ size.name }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.package.package_group") }}
                  </th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="package_item in table_rows"
                  :key="package_item.id"
                >
                  <td class="table-cell-main">
                    {{ getProducerLabelByPackage(package_item) }}
                  </td>
                  <td class="table-cell">
                    {{
                      package_item.exporter_process_crop_category
                        .agro_exporter_crop_category.crop_category.name
                    }}
                  </td>
                  <td class="table-cell">
                    {{
                      package_item.exporter_process_crop_variety
                        .agro_exporter_crop_variety.crop_variety.name
                    }}
                  </td>
                  <td class="table-cell">
                    {{
                      package_item.exporter_process_brand.agro_exporter_brand
                        .name
                    }}
                  </td>
                  <td class="table-cell">
                    {{
                      $t("model.package.exporter_process_crop_package_value", {
                        name: package_item.exporter_process_crop_package.name,
                        weight:
                          package_item.exporter_process_crop_package
                            .gross_weight
                      })
                    }}
                  </td>
                  <td
                    scope="col"
                    v-for="size in crop_sizes"
                    :key="size.id"
                    class="table-cell"
                  >
                    {{
                      package_item.package_crop_sizes.find(
                        ps => ps.id == size.id
                      )?.quantity
                    }}
                  </td>
                  <td class="table-cell">
                    {{ package_item.package_group.pg_code }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PackagesTab",
  props: {
    package_groups: {
      type: Array,
      required: true
    }
  },
  computed: {
    crop_sizes: function () {
      let arr = [];
      this.packages.forEach(item => {
        if (
          arr.map(i => i.id).includes(item.exporter_process_crop_size.id) ==
          false
        ) {
          arr.push({
            id: item.exporter_process_crop_size.id,
            name: item.exporter_process_crop_size.agro_exporter_crop_size
              .crop_size.name
          });
        }
      });
      return arr;
    },
    packages: function () {
      let packages = [];
      this.package_groups.forEach(function (group) {
        packages = packages.concat(group.packages);
      });
      return packages;
    },
    table_rows: function () {
      var rows = [];
      this.packages.forEach(package_item => {
        let row = rows.find(row => this.findRow(row, package_item));

        let row_crop_size = {
          id: package_item.exporter_process_crop_size.id,
          quantity: package_item.quantity
        };
        if (row) {
          let find_package = row.package_crop_sizes.find(
            item => item.id == package_item.exporter_process_crop_size.id
          );

          if (find_package) find_package.quantity += package_item.quantity;
          else row.package_crop_sizes.push(row_crop_size);
        } else {
          rows.push({
            ...package_item,
            package_crop_sizes: [row_crop_size]
          });
        }
      });
      rows.sort((a, b) => {
        if (
          (a.producer?.name || a.organization?.name) >
          (b.producer?.name || b.organization?.name)
        )
          return 1;
        if (
          (a.producer?.name || a.organization?.name) <
          (b.producer?.name || b.organization?.name)
        )
          return -1;
        return 0;
      });
      return rows;
    }
  },

  methods: {
    findRow: function (row, package_item) {
      return (
        row.producer?.id == package_item.producer?.id &&
        row.organization?.id == package_item.organization?.id &&
        row.package_group_id == package_item.package_group_id &&
        row.exporter_process_crop_category.id ==
          package_item.exporter_process_crop_category.id &&
        row.exporter_process_crop_variety.id ==
          package_item.exporter_process_crop_variety.id &&
        row.exporter_process_crop_package.id ==
          package_item.exporter_process_crop_package.id &&
        row.exporter_process_brand.id == package_item.exporter_process_brand.id
      );
    },
    getProducerLabelByPackage: function (package_item) {
      if (package_item) {
        if (package_item.producer) return package_item.producer.name;
        return package_item.organization.name;
      }
      return "";
    },
  }
};
</script>
